import moment from 'moment';
import _ from 'lodash';
import {
  SOCKET_CHAT_NEW_MESSAGE,
  GET_CHAT_HEALTH_PLAN_LIST,
  GET_CHAT_HEALTH_PLAN_MEMBERS_LIST,
  SET_ROOM_ID,
  GET_HEALTH_PLAN_CHAT_MESSAGES,
  SEND_HEALTH_PLAN_CHAT_MESSAGE,
  SET_TOTAL_MESSAGES_COUNT,
  SET_CHAT_LOADING,
  GET_MARKED_HEALTH_PLANS,
  MARK_HEALTH_PLAN,
  SET_SELECTED_USER,
  MARK_HEALTH_PLAN_ACTIVE,
  MARK_HEALTH_PLAN_CHAT_SEEN,
  CHAT_TYPING,
  SET_CHAT_USERS_LOADING,
  SET_CHAT_DIRECT_LOADING,
  GET_UNSEEN_COUNT,
  SOCKET_CHAT_NEW_MESSAGE_ANOTHER_HEALTH_PLAN,
  GET_MESSAGE_LIST_BY_ID,
  GET_CHAT_ASSIGN_TO_LIST,
  ASSIGN_USER_TO_HEALTH_PLAN,
  GET_CHAT_ASSIGNED_USER,
  MESSAGE_SEEN,
  SET_ANOTHER_PAGE_ROOM, RESET_CHAT, GET_CHAT_ASSIGN_TO_LIST_WITH_AGENTS,
} from '../actions/chat';
import accountHelpers from '../../utils/accountHelpers';

const initialState = {
  newMessagesCount: 0,
  messagesList: [],
  isScrollToTop: false,
  healthPlanList: [],
  markedHealthPlans: [],
  chatMembersList: [],
  chatMembersListTotalPages: 1,
  chatMembersListCurrentPage: 1,
  room: {},
  healthPlanId: '',
  // receiverId: '',
  totalMessagesCount: 0,
  chatLoading: true,
  chatUsersLoading: false,
  chatDirectLoading: false,
  selectedUser: {},
  activeHealthPlan: {},
  typing: false,
  unSeenCount: '',
  assignToList: [],
  assignToListWithAgents: [],
  assignedUser: {},
  failedMessages: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SOCKET_CHAT_NEW_MESSAGE:
      const findRoom = state.chatMembersList.find((user) => user.chatRoom?.id === payload.roomId);

      return {
        ...state,
        markedHealthPlans: state.markedHealthPlans.map((plan) => (
          plan.healthPlanId === payload.healthPlanId && payload.roomId !== state.room.id
            ? { ...plan, unSeenCount: plan.unSeenCount + 1 } : plan)),

        newMessagesCount: state.newMessagesCount + 1,

        messagesList: payload.roomId === state.room.id
          ? [...state.messagesList, {
            ...payload,
            id: payload.messageId,
            createdAt: moment().utc(),
            name: payload.senderName,
            link: payload.senderAvatar,
          }]
          : [...state.messagesList],

        chatMembersList: findRoom && state.room.id !== payload.roomId
          ? [{
            ...findRoom,
            unSeenCount: findRoom.unSeenCount + 1,
            chatRoom: {
              ...findRoom.chatRoom,
              messages: [{
                ...findRoom.chatRoom.messages[0],
                message: payload.message,
                createdAt: moment().utc(),
              }],
            },
          },
          ...state.chatMembersList.filter((user) => user.chatRoom?.id !== payload.roomId)]

          : state.chatMembersList.map((user) => (user.chatRoom?.id === payload.roomId
            ? {
              ...user,
              chatRoom: {
                ...user.chatRoom,
                messages: [{ ...user.chatRoom.messages[0], message: payload.message }],
              },
            }
            : user)),
        unSeenCount: state.unSeenCount + (state.room.id === payload.roomId ? 0 : 1),
        isScrollToTop: true,
        typing: false,
      };

    case SOCKET_CHAT_NEW_MESSAGE_ANOTHER_HEALTH_PLAN:
      return {
        ...state,
        unSeenCount: state.unSeenCount + 1,
        markedHealthPlans: state.markedHealthPlans.map((plan) => (
          { ...plan, unSeenCount: plan.unSeenCount + (plan.healthPlanId === payload.healthPlanId ? 1 : 0) })),
      };

    case SET_ANOTHER_PAGE_ROOM.SUCCESS:
      return {
        ...state,
        unSeenCount: state.unSeenCount + 1,
        chatMembersList: [
          {
            ...payload.data,
            name: payload.data.room.user.name,
            id: payload.data.room.user.id,
            healthPlanId: payload.data.room.healthPlanId,
            link: payload.data.room.user.link,
            unSeenCount: (payload.data.unSeenCount || 0) + 1,
            chatRoom: {
              ...payload.data.room,
              messages: [{ ...payload.data.room.messages[0] }],
            },
          },
          ...state.chatMembersList],
        markedHealthPlans: state.markedHealthPlans.map((plan) => (
          plan.healthPlanId === payload.data.room.healthPlanId
          && payload.data.room.id !== state.room.id
            ? { ...plan, unSeenCount: plan.unSeenCount + 1 } : plan)),
      };

    case GET_CHAT_HEALTH_PLAN_LIST.SUCCESS:
      return {
        ...state,
        healthPlanList: [...state.healthPlanList, ...payload.data.healthPlans],
      };

    case GET_CHAT_HEALTH_PLAN_MEMBERS_LIST.SUCCESS:
      return {
        ...state,
        chatMembersList: +payload.data.page > 1
          ? _.uniqBy([...state.chatMembersList, ...payload.data.users], 'id') : [...payload.data.users],
        chatMembersListTotalPages: +payload.data.totalPages,
        chatMembersListCurrentPage: +payload.data.page,
      };

    case GET_CHAT_ASSIGN_TO_LIST.SUCCESS:
      return {
        ...state,
        assignToList: [...payload.data.users],
      };

    case GET_CHAT_ASSIGN_TO_LIST_WITH_AGENTS.SUCCESS:
      return {
        ...state,
        assignToListWithAgents: [...payload.data.users],
      };

    case ASSIGN_USER_TO_HEALTH_PLAN.REQUEST:
      return {
        ...state,
        assignedUser: { ...payload },
      };

    case GET_CHAT_ASSIGNED_USER.SUCCESS:
      if (payload.data.users.length) {
        return {
          ...state,
          assignedUser: { ...payload.data.users[0], id: payload.data.users[0].userId },
        };
      }

      return {
        ...state,
        assignedUser: {},
      };

    case SET_ROOM_ID.REQUEST:
      return {
        ...state,
        room: {
          user: { id: payload.id },
        },
        chatMembersList: payload.user
          ? _.uniqBy([payload.user, ...state.chatMembersList], 'id')

          : state.chatMembersList,
        messagesList: [],
        totalMessagesCount: 0,
      };

    case SET_ROOM_ID.SUCCESS:
      return {
        ...state,
        room: {
          ...payload.data.room,
          user: payload.data.room.members.find((m) => +m.memberId === +payload.userId)?.user,
        },
        healthPlanId: payload.data.room.healthPlanId,
        chatMembersList: state.chatMembersList,
      };

    case SET_TOTAL_MESSAGES_COUNT:
      return {
        ...state,
        totalMessagesCount: payload.count,
      };

    case SET_CHAT_LOADING:
      return {
        ...state,
        chatLoading: payload.data,
      };

    case SET_CHAT_USERS_LOADING:
      return {
        ...state,
        chatUsersLoading: payload.data,
      };

    case SET_CHAT_DIRECT_LOADING:
      return {
        ...state,
        chatDirectLoading: payload.data,
      };

    case SET_SELECTED_USER:
      return {
        ...state,
        selectedUser: payload.data,
      };

    case GET_HEALTH_PLAN_CHAT_MESSAGES.SUCCESS:
      return {
        ...state,
        messagesList: payload.reset || payload.isSearched ? payload.data.messages.reverse()
          : !payload.isDownScroll ? [...payload.data.messages.reverse(), ...state.messagesList]
            : [...state.messagesList, ...payload.data.messages.reverse()],
        totalMessagesCount: !payload.isDownScroll ? payload.data.totalMessages : state.totalMessagesCount,
      };

    case SEND_HEALTH_PLAN_CHAT_MESSAGE.REQUEST:
      if (!payload.resend) {
        return {
          ...state,
          messagesList: [...state.messagesList, {
            ...payload,
            createdAt: moment().utc(),
            senderId: accountHelpers.getUser().id,
            link: accountHelpers.getUser().link,
          }],
          chatMembersList: state.chatMembersList.map((member) => (member.chatRoom?.id === payload.roomId
            ? {
              ...member,
              chatRoom: {
                ...member.chatRoom,
                messages: [{
                  ...member.chatRoom.messages[0],
                  message: payload.message,
                  files: payload.files || [],
                  createdAt: moment().utc(),
                }],
              },
            }
            : member)),
          newMessagesCount: state.newMessagesCount + 1,
        };
      }
      const resendMsg = state.messagesList.find((msg) => msg.id === payload.id);
      delete resendMsg.resend;

      return {
        ...state,
        messagesList: [...state.messagesList.filter((msg) => msg.id !== resendMsg.id), {
          ...resendMsg,
          createdAt: moment().utc(),
          senderId: accountHelpers.getUser().id,
        }],

        chatMembersList: state.chatMembersList.map((member) => (member.chatRoom?.id === payload.roomId
          ? {
            ...member,
            chatRoom: {
              ...member.chatRoom,
              messages: [{ ...member.chatRoom.messages[0], message: payload.message, files: payload.files || [] }],
            },
          }

          : member)),

        failedMessages: state.failedMessages.filter((fail) => fail !== resendMsg.id),

        newMessagesCount: state.newMessagesCount + 1,
      };

    case SEND_HEALTH_PLAN_CHAT_MESSAGE.SUCCESS:
      const { lastMessageId, id, roomId } = payload;

      return {
        ...state,
        messagesList: state.messagesList.map((message) => (message.id === lastMessageId
          ? { ...message, id } : message)),
        chatMembersList: state.chatMembersList.map((member) => (member.chatRoom?.id === roomId
          ? {
            ...member,
            chatRoom: {
              ...member.chatRoom,
              messages: [{ ...member.chatRoom.messages[0], id }],
            },
          }
          : member)),
      };

    case SEND_HEALTH_PLAN_CHAT_MESSAGE.FAIL:

      return {
        ...state,
        failedMessages: [payload.id, ...state.failedMessages],
      };

    case GET_MARKED_HEALTH_PLANS.SUCCESS:
      return {
        ...state,
        markedHealthPlans: payload.data.marked,
      };

    case MARK_HEALTH_PLAN.REQUEST:
      if (state.activeHealthPlan.id === payload) {
        return {
          ...state,
          chatMembersList: [],
          messagesList: [],
          selectedUser: {},
          room: {},
          activeHealthPlan: {},
          assignedUser: {},
          failedMessages: [],
          unSeenCount: state.unSeenCount - state.activeHealthPlan.unSeenCount,
        };
      }

      // const healthP = state.markedHealthPlans.find((plan) => plan.plan.id === payload);

      return {
        ...state,
        markedHealthPlans: state.markedHealthPlans.filter((plan) => plan.healthPlanId !== payload),
      };

    case MARK_HEALTH_PLAN.SUCCESS:
      return {
        ...state,
      };

    case MARK_HEALTH_PLAN_ACTIVE.SUCCESS:
      const activePlan = state.markedHealthPlans.find((plan) => plan.healthPlanId === payload.data.plan.id);

      return {
        ...state,
        activeHealthPlan: payload.data.plan,
        markedHealthPlans: [activePlan,
          ...state.markedHealthPlans.filter((plan) => plan.healthPlanId !== payload.data.plan.id)],
        room: {},
        messagesList: [],
      };

    case MARK_HEALTH_PLAN_CHAT_SEEN.REQUEST:
      const roomUnSeenCount = +state.chatMembersList.find((u) => u.chatRoom.id === payload)?.unSeenCount;

      return {
        ...state,
        markedHealthPlans: state.markedHealthPlans.map((p) => (p.healthPlanId === state.activeHealthPlan.id
          ? { ...p, unSeenCount: p.unSeenCount - roomUnSeenCount }
          : p
        )),
        chatMembersList: state.chatMembersList.map((user) => (user.chatRoom?.id === payload
          ? { ...user, unSeenCount: 0 }
          : user)),
        unSeenCount: (+state.unSeenCount - roomUnSeenCount),
      };

    case CHAT_TYPING:
      return {
        ...state,
        typing: payload.data.roomId === state.room.id ? payload.typing : state.typing,
      };

    case MESSAGE_SEEN:
      return {
        ...state,
        messagesList: state.messagesList.map((message) => {
          if (payload.messageIds.includes(message.id)) {
            return {
              ...message,
              seenList: payload.messageIds,
            };
          }
          return message;
        }),
      };

    case GET_UNSEEN_COUNT.SUCCESS:
      return {
        ...state,
        unSeenCount: payload.data.count,
      };

    case GET_MESSAGE_LIST_BY_ID.SUCCESS:
      return {
        ...state,
        messagesList: [...payload.data.messages.reverse()],
        totalMessagesCount: payload.data.totalMessages,
      };

    case RESET_CHAT:
      return {
        ...initialState,
        unSeenCount: state.unSeenCount,
      };

    default:
      return state;
  }
};

export default reducer;
